import type { User } from "../../slices/authSlice"
import { FiUsers } from "react-icons/fi"
import SectionHeader from "../ui/SectionHeader"
import RepresentativeSection from "../trademark/representative/RepresentativeSection"
import PatentApplicantSection from "./PatentApplicantSection"

// EP1001 counterpart of the shared ApplicantAndRepresentativeWrapper
// (SCRUM-55): same two-column layout and the same fixed EPO
// representative card, but the applicant column uses the
// patent-specific PatentApplicantSection.

type PatentApplicantAndRepresentativeProps = {
  onApplicantChange: (value: any) => void
  orderingParty?: Partial<User> | null
  initialData?: any[]
  disabled?: boolean
}

export default function PatentApplicantAndRepresentative({
  onApplicantChange,
  initialData,
  orderingParty,
  disabled = false
}: PatentApplicantAndRepresentativeProps) {
  return (
    <div id="applicant" className="scroll-mt-28 border-t border-gray-300 pt-4">
      <SectionHeader
        icon={<FiUsers size={20} />}
        title="Parties to the proceedings, inventors"
        subtitle="Provide information about the applicant(s) and representative(s)."
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <PatentApplicantSection
          orderingParty={orderingParty}
          onChange={onApplicantChange}
          initialData={initialData}
          disabled={disabled}
        />

        <RepresentativeSection disabled={disabled} officeLabel="EPO" />
      </div>
    </div>
  )
}
